/* src/app/components/menu-modal/menu-modal.component.scss */
app-menu-modal {
  position: relative;
  text-transform: capitalize;
}
.header {
  margin-bottom: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  width: 141.35px;
  height: 21px;
  margin-left: auto;
  margin-right: auto;
}
.close {
  width: 22.05px;
  height: 22px;
}
.lang-icon {
  margin-top: 20px;
  height: 30px;
  width: 30px;
}
.wrapper {
  color: var(--color-black);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.wrapper .center-section {
  padding: 30px 15px 15px 20px;
}
.wrapper .header-section {
  padding: 8px 0;
}
.separator {
  width: 100%;
  margin: 16px 0;
}
ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}
.version {
  opacity: 0.3;
  font-size: x-small;
  color: #fff;
}
ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}
.name {
  margin-bottom: 5px;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.email {
  font-size: 14px;
  line-height: 121%;
  letter-spacing: 2%;
  vertical-align: middle;
}
a {
  text-decoration: none;
  color: #fff;
}
ion-button {
  width: 100%;
  font-size: 18px;
}
.lang-row {
  font-size: 20px;
  font-family: AppFont, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
ion-col {
  font-size: 20px;
  color: #fff;
}
.selected {
  opacity: 1 !important;
}
.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}
ion-icon {
  zoom: 1.1;
}
ion-row {
  margin-top: 6px;
}
.header-wrap {
  margin: 10px;
}
.header-wrap-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-black);
}
.selected {
  opacity: 1 !important;
}
.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
  color: #fff;
}
.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-lang div:first-child {
  margin-left: 20px;
}
.footer-lang div {
  margin: 0 5px;
  text-align: center;
  width: 48%;
  --border-color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  background: transparent;
  border-radius: 50px;
  overflow: hidden;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
}
.footer-lang div .flag {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  border-radius: 50%;
  overflow: hidden;
}
.footer-lang div span {
  text-transform: uppercase;
  font-size: 14px !important;
  color: var(--ion-color-primary);
}
.footer-lang div.selected span {
  color: white;
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
  border: none;
}
.footer-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.footer-block .lang-block {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.footer-block .lang-block .lang-item {
  padding: 5px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  margin-right: 10px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  border: 1px solid var(--color-black);
}
.footer-block .lang-block .lang-item ion-icon {
  width: 18px;
  height: 18px;
  padding: 0;
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
}
.footer-block .lang-block .lang-item {
  background: white;
}
.footer-block .lang-block .lang-item h3 {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: #fff;
  transition: color 0.3s ease;
}
.footer-block .lang-block .lang-item.selected {
  background: var(--ion-color-primary);
}
.footer-block .lang-block .lang-item.selected ion-icon {
  opacity: 1;
}
.footer-block .lang-block .lang-item.selected h3 {
  color: white;
}
.footer-block .logout {
  zoom: 1.5;
  margin: 0;
}
.footer-section-desktop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-top: 1px solid #383838;
}
.footer-section-desktop .left-section p {
  font-size: 12px;
  padding-bottom: 10px;
  cursor: pointer;
}
.footer-section-desktop .left-section p:hover {
  color: var(--ion-color-primary);
}
.footer-section-desktop .right-section .lang-block {
  display: flex;
  align-items: center;
}
.footer-section-desktop .right-section .lang-block .vertical-line {
  margin: 0 20px;
  width: 1px;
  height: 20px;
  background: var(--color-black);
}
.footer-section-desktop .right-section .lang-block h3 {
  font-size: 16px;
  cursor: pointer;
}
@media (min-width: 991px) {
  .block-items {
    height: 200px;
  }
}
.logout-block {
  width: fit-content;
  padding: 10px;
  border: 1px solid var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
  margin-left: 20px;
  min-width: 150px;
  text-align: center;
  color: #fff;
}
ion-row:hover ion-col {
  color: var(--ion-color-primary);
}
/*# sourceMappingURL=menu-modal.component.css.map */
